import sealToUsersReducer from "./reducer"
import sealToUsersSaga from "./sagas"

const saga = {
  reducers: sealToUsersReducer,
  sagas: sealToUsersSaga
}

export default saga